import React from "react";
import {Box, Tab, Tabs} from "@material-ui/core";
import {IManagementStore} from "Stores/Management/types";
import {inject, observer} from "mobx-react";
import {Organisation} from "@src/Interfaces/Entity/Organisation";
import {observable, computed} from "mobx";
import filterByTableColumns from "@src/Tools/filterByTableColumns";
import OrganisationsTable from "./OrganisationsTable/OrganisationsTable";
import {Values} from "@src/Tools/Values";
import {IAuthStore} from "@src/Stores/Auth/types";
import FullWidthSearch from "@src/Shared/Components/FullWidthSearch/FullWidthSearch";
import {FullWidthFlexBox} from "@src/Shared/Components/FullWidthFlexBox";
import {STGrid} from "@src/Components/Pages/Main/Content/Locations/LocationsContent/styles";
import ResultsAreEmptyLabel from "@src/Components/Ui/ResultsAreEmpty";
import {STFormContentWrapper, STTabsContentWrapper} from "../../OAuth/styles";
import {OrganisationDialog} from "./OrganisationDialog/OrganisationDialog";
import { AddButton } from "@src/Shared/Components/AddButton/AddButton";

interface IProps {
    management?: IManagementStore;
    auth?: IAuthStore;
}

@inject("auth", "management")
@observer
class OrganisationsContent extends React.Component<IProps> {
    @observable searchText: string = "";
    @observable showAddOrganisationDialog: boolean = false;

    @computed get filteredOrganisations() {
        return filterByTableColumns<Organisation>(
            this.props.management.organisations,
            this.searchText
        );
    }

    handleChange = (text: string) => {
        this.searchText = text
    };

    handleAddOrganisationDialog = () => {
        this.showAddOrganisationDialog = !this.showAddOrganisationDialog;
    }

    render() {
        return (
            <>
                <FullWidthFlexBox>
                    <STTabsContentWrapper>
                        <Tabs
                            value={0}
                            indicatorColor="primary"
                            textColor="primary"
                            variant={"standard"}
                        >
                            <Tab label={Values.getLocalizationValue("organisations")}/>
                        </Tabs>
                    </STTabsContentWrapper>

                    {this.props.auth.user.location.primary &&
                        <AddButton
                            onClick={() => this.handleAddOrganisationDialog()}
                            text={Values.getLocalizationValue("addOrganisation")}
                        />
                    }
                </FullWidthFlexBox>

                <STFormContentWrapper>
                    <Box>
                        <FullWidthSearch
                            value={this.searchText}
                            onChange={(text: string) => this.handleChange(text)}
                        />

                        <STGrid item xs>
                            {this.filteredOrganisations.length > 0
                                ? <OrganisationsTable organisations={this.filteredOrganisations}/>
                                : <ResultsAreEmptyLabel/>
                            }
                        </STGrid>
                    </Box>
                </STFormContentWrapper>

                {this.showAddOrganisationDialog &&
                    <OrganisationDialog
                        organisation={null}
                        isOpened={this.showAddOrganisationDialog}
                        onClose={() => this.showAddOrganisationDialog = false}
                        isEdit={false}
                    />
                }
            </>
        );
    }
}

export default OrganisationsContent;
